import React, { useEffect, useState } from 'react';
import axios from '../../../utils/axiosWithAuth';

const UnsubscribedList = () => {
  const [unsubscribed, setUnsubscribed] = useState([]);
  const [loading, setLoading] = useState(true);

  const [unsubSearch, setUnsubSearch] = useState('');
  const [unsubPage, setUnsubPage] = useState(1);
  const unsubPerPage = 10;

  useEffect(() => {
    fetchUnsubscribed();
  }, []);

  const fetchUnsubscribed = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/email/unsubscribed`);

      const data = Array.isArray(res.data) ? res.data : [];
      setUnsubscribed(data);
    } catch (err) {
      console.error('Failed to load unsubscribed users:', err.message);
    } finally {
      setLoading(false);
    }
  };

  const filteredUnsub = unsubscribed.filter((u) =>
    u.email.toLowerCase().includes(unsubSearch.toLowerCase())
  );
  const paginatedUnsub = filteredUnsub.slice(
    (unsubPage - 1) * unsubPerPage,
    unsubPage * unsubPerPage
  );

  if (loading) return <div className="text-center py-4">⏳ Loading unsubscribed users...</div>;

  return (
    <div className="container py-4">
      <h2>🚫 Unsubscribed Users</h2>

      <input
        type="text"
        value={unsubSearch}
        onChange={(e) => {
          setUnsubSearch(e.target.value);
          setUnsubPage(1);
        }}
        placeholder="Search by email"
        className="form-control my-3"
        style={{ maxWidth: '400px' }}
      />

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Email</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUnsub.map((u) => (
            <tr key={u.email}>
              <td>{u.email}</td>
              <td>{new Date(u.date || u._id?.getTimestamp?.()).toLocaleString('en-IN')}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={unsubPage === 1}
          onClick={() => setUnsubPage(unsubPage - 1)}
        >
          ⬅ Prev
        </button>
        <span>Page {unsubPage}</span>
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={unsubPage * unsubPerPage >= filteredUnsub.length}
          onClick={() => setUnsubPage(unsubPage + 1)}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default UnsubscribedList;
